var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33301 5.33331C7.33301 4.96531 7.63167 4.66665 7.99967 4.66665C8.36767 4.66665 8.66634 4.96531 8.66634 5.33331C8.66634 5.70131 8.36767 5.99998 7.99967 5.99998C7.63167 5.99998 7.33301 5.70131 7.33301 5.33331ZM7.33301 7.33331C7.33301 6.96531 7.63167 6.66665 7.99967 6.66665C8.36767 6.66665 8.66634 6.96531 8.66634 7.33331V10.6666C8.66634 11.0346 8.36767 11.3333 7.99967 11.3333C7.63167 11.3333 7.33301 11.0346 7.33301 10.6666V7.33331ZM7.99967 13.3333C5.05901 13.3333 2.66634 10.9406 2.66634 7.99998C2.66634 5.05931 5.05901 2.66665 7.99967 2.66665C10.9403 2.66665 13.333 5.05931 13.333 7.99998C13.333 10.9406 10.9403 13.3333 7.99967 13.3333M7.99967 1.33331C4.31767 1.33331 1.33301 4.31798 1.33301 7.99998C1.33301 11.682 4.31767 14.6666 7.99967 14.6666C11.681 14.6666 14.6663 11.682 14.6663 7.99998C14.6663 4.31798 11.681 1.33331 7.99967 1.33331",
    fill: "#661C69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconViolet);
export default __webpack_public_path__ + "static/media/info-icon-violet.8bf50b39d80db57296ddf0268e4f522c.svg";
export { ForwardRef as ReactComponent };